export default __webpack_public_path__ + "static/banner3@2x-1d78d228c255aa40c7e195fe92160ed2.jpg";